import React, { memo, useEffect, useMemo, useState } from 'react';
import { useTranslation } from "react-i18next";

import { lessonsList, removeLesson } from "../../services/lessons";

import Table from "../../components/Table";
import { useNavigate, useSearchParams } from "react-router-dom";

const LessonsList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const { t } = useTranslation();

  const [list, setList] = useState([])
  const [count, setCount] = useState(0)

  const getFilterValue = (param, defaultValue) => searchParams.get(param) || defaultValue;
  const initialFilters = { page: Number(getFilterValue("page", 1)), per_page: 10, owner_type: getFilterValue("owner_type", "club") };
  const [filters, setFilters] = useState(initialFilters)
  const { page, per_page, owner_type } = filters;

  const updateSearchParams = (newFilters) => {
    const updatedParams = new URLSearchParams(searchParams);
    
    Object.entries(newFilters).forEach(([key, value]) =>
      value ? updatedParams.set(key, value) : updatedParams.delete(key)
    );
  
    setSearchParams(updatedParams);
  };

  const getList = async () => {
    const { lessons, count } = await lessonsList(filters);
    setList(lessons)
    setCount(count)
  };

  const remove = async (lesson) => {
    await removeLesson(lesson.id)
    getList();
  }

  useEffect(() => { updateSearchParams(filters); getList()}, [filters])

  const pagination = useMemo(
    () => ({
      pageIndex: page - 1,
      pageSize: per_page,
    }),
    [page, per_page]
  )

  const handlePagination = ({ pageSize, pageIndex}) => {
    setFilters({...filters, page: pageIndex + 1, per_page: pageSize })
  }

  const columns = useMemo(
    () => [
      { header: t('common.table_title'), accessorKey: 'title', cell: info => <div onClick={() => navigate("/club_admin/lessons/" + info.row.original?.id)}>{info.getValue()}</div> },
      {
        id: 'actions',
        header: " ", cell: (info) =>
          <div className='flex-end ai-center'>
            <span className={`new_label new_label-${info.row.original?.published ? 'success' : 'default'}`}>
              {info.row.original?.published ? t("common.published") : t("common.draft")}
            </span>

            { !info.row.original?.locked && <i className="icon icon-trash" onClick={() => confirm(t('lessons.remove_lesson', { title: info.row.original?.title })) && remove(info.row.original)}></i> } 
            <i className="icon icon-settings" onClick={() => navigate("/club_admin/lessons/" + info.row.original?.id)}></i>
          </div>,  meta: { style: { width: 60 }}
      },
    ],
    []
  )

  return (
    <div className="team-details">
      <div className="team-details-header">
        <div className="team-details-header-text">{t('lessons.lessons')}</div>
        <button className="button button-add" onClick={() => navigate("/club_admin/lessons/new")}>{t('buttons.lesson.add')}</button>
      </div>
      <div className="team-details-tabs">
        <div className={`team-details-tabs-option pointer ${owner_type === "club" ? 'active' : ''}`} onClick={() => owner_type !== 'clubs' && setFilters({...filters, owner_type: 'club', page: 1 })}>{t('lessons.club_lessons')}</div>
        <div className={`team-details-tabs-option pointer ${owner_type === "supercoach" ? 'active' : ''}`} onClick={() =>  owner_type !== 'supercoach' && setFilters({...filters, owner_type: 'supercoach', page: 1 })}>{t('lessons.supercoach_lessons')}</div>
      </div>
      <div className="team-details-list">
        <Table {...{ data: list, columns, pageCount: Math.ceil(count / per_page), manualPagination: true, state: { pagination }, onPaginationChange: (e) => handlePagination(e(pagination)) }}/>
      </div>
    </div>

  )
};

export default memo(LessonsList);


